// extracted by mini-css-extract-plugin
export default {"aboutUsContainer":"shipping_payment_aboutUsContainer__ToKll"};